// extracted by mini-css-extract-plugin
export default {"main":"HomeLast_main__Fj+cY","main1":"HomeLast_main1__pXb1w","main2":"HomeLast_main2__Of-mO","main2img":"HomeLast_main2img__Pbe1u","main2upper":"HomeLast_main2upper__wzkX3"};